import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio } from "@mui/material";
import { Consts } from "../../pages/consts";
import DayTimeIntake from "./DayTimeIntake";

const DayTimeIntakes = ({timingType, intakes, onSetIntake}) => {
  const { t: t } = useTranslation();

  return (
    <div className="w3-row ">
      <FormControlLabel
        value={Consts.DAY_TIMES}
        control={<Radio />}
        label={<label>{t("select_day_times")}</label>}
        className="w3-col s3 w3-mobile"
      />
      {timingType === Consts.DAY_TIMES && (
        <div className="w3-col s8 w3-mobile">
          <div className="w3-row ">
            {intakes?.map((intake, i) => {
              return (
                <div
                  className="w3-half w3-padding-small"
                  key={`dayTimeIntake${i}`}
                >
                  <DayTimeIntake index={i} intake={intake} onSetIntake={onSetIntake}/>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default DayTimeIntakes;
